// extracted by mini-css-extract-plugin
export default {"chatGroupWrapper":"float_chatGroupWrapper__3pnKe","header":"float_header__hgw0q","left":"float_left__pOjcC","listLayer":"float_listLayer__5j47v"};